
(function() {
  var result = { translations: { "vi": { "i18n": { "duration": { "seconds": "{{ seconds }} gi\xE2y", "minutes": "{{ minutes }} ph\xFAt", "hours": "{{ hours }} gi\u1EDD", "hoursAndMinutes": "{{ hours }} gi\u1EDD {{ minutes }} ph\xFAt", "days": "{{ days }} ng\xE0y", "shortForm": { "seconds": "{{ seconds }} gi\xE2y", "minutes": "{{ minutes }} ph\xFAt", "hours": "{{ hours }} gi\u1EDD", "days": "{{ days }} ng\xE0y", "hoursAndMinutes": "{{ hours }} gi\u1EDD {{ minutes }} ph\xFAt" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, m\xE1y l\u1EBB {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "vi": "static-7.1107"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1107",
    "ar-eg": "static-7.1107",
    "bg": "static-7.1107",
    "bn": "static-7.1107",
    "ca-es": "static-7.1107",
    "cs": "static-7.1107",
    "da": "static-7.1107",
    "de": "static-7.1107",
    "el": "static-7.1107",
    "en-gb": "static-7.1107",
    "en": "static-7.1107",
    "es-mx": "static-7.1107",
    "es": "static-7.1107",
    "et": "static-7.1107",
    "fi": "static-7.1107",
    "fr-ca": "static-7.1107",
    "fr": "static-7.1107",
    "he-il": "static-7.1107",
    "hi": "static-7.1107",
    "hr": "static-7.1107",
    "hu": "static-7.1107",
    "id": "static-7.1107",
    "it": "static-7.1107",
    "ja": "static-7.1107",
    "ko": "static-7.1107",
    "lt": "static-7.1107",
    "ms": "static-7.1107",
    "nl": "static-7.1107",
    "no": "static-7.1107",
    "pl": "static-7.1107",
    "pt-br": "static-7.1107",
    "pt-pt": "static-7.1107",
    "ro": "static-7.1107",
    "ru": "static-7.1107",
    "sk": "static-7.1107",
    "sl": "static-7.1107",
    "sv": "static-7.1107",
    "th": "static-7.1107",
    "tl": "static-7.1107",
    "tr": "static-7.1107",
    "uk": "static-7.1107",
    "vi": "static-7.1107",
    "x-pseudo": "static-7.1107",
    "zh-cn": "static-7.1107",
    "zh-hk": "static-7.1107",
    "zh-tw": "static-7.1107"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:vi', {version: 'static-7.1107'}); }
})();


